export default __webpack_public_path__ + "images/0x41742dcc2f74f870473031c77e63f2c8cceb0815.png";